module.exports = __webpack_public_path__ + "static/img/sb2.8aee12a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sb2.png
// module id = Ebap
// module chunks = 9